import { render } from "./EditTaskModal.vue?vue&type=template&id=b6fb33cc&scoped=true"
import script from "./EditTaskModal.vue?vue&type=script&lang=js"
export * from "./EditTaskModal.vue?vue&type=script&lang=js"

import "./EditTaskModal.vue?vue&type=style&index=0&id=b6fb33cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6fb33cc"]])

export default __exports__